/**
 * Enum describing in which mode the Content Delivery API
 * is being used.
 */
export enum ContextMode {
	/**
	 * Default mode, also known as view mode.
	 */
	Default = 'DEFAULT',

	/**
	 * Preview mode in the CMS shell.
	 */
	Preview = 'PREVIEW',

	/**
	 * Edit mode in the CMS shell.
	 */
	Edit = 'EDIT',
}

export interface ContentArea {
	items: Array<ContentData>;
}

/**
 * Interface describing content.
 */
export interface ContentData {
	/**
	 * Reference to the content.
	 */
	blockId: string;

	/**
	 * Content type.
	 */
	contentType: string;

	/**
	 * Date this content was created.
	 */
	created: Date;

	/**
	 * Date this content was changed.
	 */
	changed: Date;

	/**
	 * Date this content was saved.
	 */
	saved: Date;

	/**
	 * Date this content was published.
	 */
	startPublish: Date;

	/**
	 * Name of the content.
	 */
	name: string;

	contentName: string;
}
